import React from "react";
import { Component } from "react";
import ButtonIcon from '../../../../button';
class SummaryHeader extends Component {
    render(){
        return(
            <div>
                <h1>
                    User
                </h1>
                <ButtonIcon onClick={()=>alert("click")} iconLeft="file-excel" iconSize="17px" customClassName="header-filter-button" labelName="Export to excel"/> 
            </div>
        )
    }
}

export default SummaryHeader;